module.exports = __webpack_public_path__ + "img/Stop.6212638f.svg";